<div class="text-modal--wrapper">
    <div [innerHTML]="modalData | safeHtml"></div>
</div>